import './CasesPage.css'
import { useNavigate } from 'react-router-dom'
import { Row, Col, Card, Alert, FormLabel } from 'react-bootstrap'
import { DcsPermissions, GridCellEnum, ICustomColumn, IDropDownValue, IPageProps, IRootState } from 'types'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { FormElement, Field, Form, FormClassComponent, FormRenderProps } from '@progress/kendo-react-form'
import { AddButton, FormDropDownList, FormInput, FormTextArea, MessageAlert, PageHeader } from 'components'
import SAGrid, { GetDataResponse, GridGetDataProps, ISAGridRef } from 'components/Grid/SAGrid'
import { V1ApiCasesClient, V1ApiUsersClient } from 'core/http-common'
import { DeletedStateEnum, UsersDto } from '@v1UsersApi'
import toast from 'core/toast'
import { Skeleton } from '@progress/kendo-react-indicators'
import { ComboBoxChangeEvent, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns'
import ConfirmModal from 'components/Modals/ConfirmModal'
import { BulkIdsDto, BulkUpdateCases, CaseDto, CaseReasonDto, CaseStatusDto, CaseSubReasonDto, CaseSubStatusDto, CasesViewDto } from '@v1CasesApi'
import { endLoadingAction, startLoadingAction } from 'state/actions/appActions'
import { hasPermission } from 'state/reduxHelpers'
import { DEFAULT_PERMISSION_MESSAGE } from 'core/consts'
import CasesGrid from 'components/Cases/CasesGrid'

const CasesPage = ({ title }: IPageProps) => {

    return (
        <CasesGrid showClosedCases={true} showOpenCases={true} customColumns={undefined} dealerId={undefined} />
    )
}
export default CasesPage